import { useTranslation } from 'react-i18next'

import styles from './MatchesList.module.scss'

const MatchesList = ({ matches }) => {
  const { t } = useTranslation('common')
  if (!Array.isArray(matches) || matches.length === 0) {
    return <div className={styles.empty}>{t('plagiarism.no_matches')}</div>
  }

  return (
    <ul className={styles.list}>
      {matches.map((m, idx) => {
        const pct =
          m.match_percent != null
            ? Number(m.match_percent)
            : m.similarity != null
            ? Number(m.similarity) * 100
            : null
        return (
          <li key={idx} className={styles.item}>
            <div className={styles.head}>
              <div className={styles.docId}>
                {m.url ? (
                  <a href={m.url} target="_blank" rel="noreferrer">
                    {m.url}
                  </a>
                ) : (
                  <span>{t('plagiarism.doc_label', { id: m.doc_id ?? idx + 1 })}</span>
                )}
              </div>
              {pct != null && (
                <div className={styles.percent}>{pct.toFixed(1)}%</div>
              )}
            </div>
            {m.snippet && <p className={styles.snippet}>{m.snippet}</p>}
          </li>
        )
      })}
    </ul>
  )
}

export default MatchesList
